define(
  'SuiteCommerce.ItemBadges.Instrumentation.Collection',
  [
    'SuiteCommerce.ItemBadges.Instrumentation.Model',
    'underscore',
    'Backbone'
  ],
  function define(
    model,
    _,
    Backbone
  ) {
    'use strict';
    return Backbone.Collection.extend({
      model: model
    });
  }
);
